import React from 'react';
import styles from './track.module.scss';

export default function Track() {
  return (
    <div className={styles.wrapper}>Track</div>
  );
}
